
<template>
  <div class="content search_content firm_category_wrapper">
    <v-row class="search_box">
      <v-col>
        <topNav></topNav>
      </v-col>
    </v-row>
    <div class="main_container">
      <div class="md_title mart24 marb12">分类统计</div>
      <div class="fix_btns">
        <div class="btn" v-if="activeKey == 0" @click="onExportPa">
          导出专利数据
        </div>
        <div class="btn" v-if="activeKey == 1" @click="onExportTm">
          导出商标数据
        </div>
        <div class="btn" v-if="activeKey == 2" @click="onExportRz">
          导出软著数据
        </div>
        <div class="btn" v-if="activeKey == 3" @click="onExportIc">
          导出集成电路数据
        </div>
        <div class="btn" v-if="activeKey == 4" @click="onExportSr">
          导出双软数据
        </div>
        <div class="btn" v-if="activeKey == 5" @click="onExportPct">
          导出PCT数据
        </div>
        <div class="btn" v-if="activeKey == 6" @click="onExportStr">
          导出标准制定数据
        </div>

        <div class="btn btn1" @click="onExportAll">导出全部数据</div>
      </div>
    </div>
    <div class="tabs_wrapper grey_tabs">
      <v-tabs v-model="activeKey" @change="handleChange">
        <v-tab key="0">专利</v-tab>
        <v-tab key="1">商标</v-tab>
        <v-tab key="2">软著</v-tab>
        <v-tab key="3">集成电路</v-tab>
        <v-tab key="4">双软</v-tab>
        <v-tab key="5">PCT</v-tab>
        <v-tab key="6">标准制定</v-tab>
        <v-tab key="7">重点产业</v-tab>
        <v-tab-item key="0">
          <div class="category_main">
            <v-row class="category_top border">
              <v-col sm="12" md="12">
                <div class="item">
                  <v-col sm="12" md="2">
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="lefts_zuanli">
                          <div class="name">专利总数</div>
                          <div class="num_wrapper">
                            <span
                              class="num"
                              v-if="categorySum[0] && categorySum[0].num"
                              >{{ categorySum[0].num }}</span
                            >
                            <span class="num" v-else>0</span>
                            <span class="tip">件</span>
                          </div>
                        </div>
                        <div class="rights_zuanli">
                          <div class="sm_item">
                            <div class="img"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col sm="12" md="2">
                    <div class="item_wrapper">
                      <div class="item">
                        <div class="lefts_zuanli">
                          <div class="name">发明授权</div>
                          <div class="num_wrapper">
                            <span
                              class="num"
                              v-if="categorySum[0] && categorySum[0].发明授权"
                              >{{ categorySum[0].发明授权 }}</span
                            >
                            <span class="num" v-else>0</span>
                            <span class="tip">件</span>
                          </div>
                        </div>
                        <div class="rights_zuanli">
                          <div class="sm_item">
                            <div class="img03"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col sm="12" md="2">
                    <div class="item">
                      <div class="lefts_zuanli">
                        <div class="name">有效专利</div>
                        <div class="num_wrapper">
                          <span class="num">
                            {{ effPatent }}
                          </span>
                          <!-- <span
                            class="num"
                            v-if="categorySumTwo[0] && categorySumTwo[0].num"
                            >{{ categorySumTwo[0].num }}</span
                          > -->
                          <!-- <span class="num" v-else>0</span> -->
                          <span class="tip">件</span>
                        </div>
                      </div>
                      <div class="rights_zuanli">
                        <div class="sm_item">
                          <div class="img02"></div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col sm="12" md="2">
                    <div class="item">
                      <div class="lefts_zuanli">
                        <div class="name">有效实用新型</div>
                        <div class="num_wrapper">
                          <span
                            class="num"
                            v-if="categorySum[0] && categorySum[0].有效实用新型"
                            >{{ categorySum[0].有效实用新型 }}</span
                          >
                          <span class="num" v-else>0</span>
                          <span class="tip">件</span>
                        </div>
                      </div>
                      <div class="rights_zuanli">
                        <div class="sm_item">
                          <div class="img04"></div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col sm="12" md="2">
                    <div class="item">
                      <div class="lefts_zuanli">
                        <div class="name">有效发明专利</div>
                        <div class="num_wrapper">
                          <span
                            class="num"
                            v-if="categorySum[0] && categorySum[0].有效发明专利"
                            >{{ categorySum[0].有效发明专利 }}</span
                          >
                          <span class="num" v-else>0</span>
                          <span class="tip">件</span>
                        </div>
                      </div>
                      <div class="rights_zuanli">
                        <div class="sm_item">
                          <div class="img05"></div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                  <v-col sm="12" md="2">
                    <div class="item">
                      <div class="lefts_zuanli">
                        <div class="name">有效外观专利</div>
                        <div class="num_wrapper">
                          <span
                            class="num"
                            v-if="categorySum[0] && categorySum[0].有效外观设计"
                            >{{ categorySum[0].有效外观设计 }}</span
                          >
                          <span class="num" v-else>0</span>
                          <span class="tip">件</span>
                        </div>
                      </div>
                      <div
                        class="rights_zuanli"
                        style="border: none !important"
                      >
                        <div class="sm_item">
                          <div class="img06"></div>
                        </div>
                      </div>
                    </div>
                  </v-col>
                </div>
                <!-- </v-row> -->
              </v-col>
            </v-row>
            <v-row class="category_center">
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">园区专利申请/授权趋势</div>
                  <!---添加图表切换的自适应---->
                  <div class="chartBox" ref="chartDom1" id="chartOne"></div>
                  <!-- <LineChart  class="chartBox" ></LineChart> -->
                </div>
              </v-col>
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">专利类型授权趋势</div>
                  <div class="chartBox" ref="chartDom2"></div>
                  <!-- <BarChart class="chartBox" ></BarChart> -->
                </div>
              </v-col>
            </v-row>
            <v-row class="category_center">
              <v-col sm="6" md="4" style="margin-top: -25px">
                <div class="item">
                  <div class="tit">专利类型分布</div>
                  <div
                    class="chartBox"
                    style="padding-bottom: 50px"
                    ref="chartDom3Type"
                  ></div>
                  <!-- <PatentCharts class="chartBox"  style="padding-bottom: 50px"></PatentCharts> -->
                </div>
              </v-col>
              <v-col sm="6" md="4" style="margin-top: -25px">
                <div class="item">
                  <div class="tit">专利法律状态分布</div>
                  <div
                    class="chartBox"
                    style="padding-bottom: 50px"
                    ref="chartDom4"
                  ></div>
                  <!-- <BarChart1
                    class="chartBox"
                    style="padding-bottom: 50px"
                  ></BarChart1> -->
                </div>
              </v-col>
              <v-col sm="12" md="4" style="margin-top: -25px">
                <div class="item">
                  <div class="tit">专利有效性分布</div>
                  <div
                    class="chartBox"
                    style="padding-bottom: 50px"
                    ref="chartDom4Effect"
                  ></div>
                  <!-- <BarChart2
                    class="chartBox"
                    style="padding-bottom: 50px"
                  ></BarChart2> -->
                </div>
              </v-col>
            </v-row>
            <!---添加的表格数据-->
            <v-row class="category_bottom">
              <v-col sm="6" md="6" style="margin-top: -25px">
                <div class="item">
                  <div class="tit">园区专利技术分布</div>
                  <div class="chartBox" ref="chartDom3"></div>
                  <!-- <technChart  class="chartBox"></technChart> -->
                </div>
              </v-col>
              <v-col sm="12" md="6" style="margin-top: -25px">
                <div class="item">
                  <div class="tit">园区企业专利拥有量排名</div>
                  <ParkRrmarkYuanqu></ParkRrmarkYuanqu>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item key="1">
          <div class="category_main">
            <v-row class="category_top">
              <v-col sm="12" md="12">
                <div class="item_shangbiao">
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num">
                          <p
                            class="text"
                            v-if="trademarNum[1] && trademarNum[1].num"
                          >
                            商标申请数：{{ trademarNum[1].num }}
                          </p>
                          <p class="text" v-else>商标申请数：0</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num_blue">
                          <p
                            class="text"
                            v-if="trademarNum[2] && trademarNum[2].num"
                          >
                            注册商标数：{{ trademarNum[2].num }}
                          </p>
                          <p class="text" v-else>注册商标数：0</p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num_green">
                          <p
                            class="text"
                            v-if="trademarNum[3] && trademarNum[3].num"
                          >
                            有效商标数：{{ trademarNum[3].num }}
                          </p>
                          <p class="text" v-else>有效商标数：</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">年度商标累计总数</div>
                  <div class="chartBoxTwo" ref="chartDom6"></div>
                </div>
              </v-col>
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">年度商标累计新增总数</div>
                  <div class="chartBoxTwo" ref="chartDom6Two"></div>
                </div>
              </v-col>
              <v-col sm="12" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">企业商标拥有量排行</div>
                  <div class="chartBox list_box" ref="chartDom5">
                    <div class="line_style">
                      <div class="td1">
                        <div class="tcenter">企业名称</div>
                      </div>
                      <div class="td2">
                        <div class="tcenter">数量</div>
                      </div>
                    </div>

                    <div
                      class="line_style hoverBtn"
                      v-for="(item, index) in datafiveMark"
                      :key="index"
                      @click="
                        onConpanyfiveMark(item.companyName, item.companyId)
                      "
                    >
                      <div class="td1">
                        <div class="num">{{ index + 1 }}</div>
                        <div class="text tit_overflow">
                          {{ item.companyName }}
                        </div>
                      </div>
                      <div class="td2">
                        <div class="num1">{{ item.num }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item key="2">
          <div class="category_main">
            <v-row class="category_top">
              <v-col sm="12" md="12">
                <div class="item_shangbiao">
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num">
                          <p
                            class="text"
                            v-if="rzDataNum[0] && rzDataNum[0].num"
                          >
                            软著申请数：{{ rzDataNum[0].num }}
                          </p>
                          <p class="text" v-else>软著申请数：</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">年度软著累计总数</div>
                  <div class="chartBox" ref="chartDom7"></div>
                </div>
              </v-col>
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">年度软著累计新增总数</div>
                  <div class="chartBox" ref="chartDom7Two"></div>
                </div>
              </v-col>
              <v-col sm="12" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">企业软著拥有量排行</div>
                  <div class="chartBox list_box" ref="chartDom5">
                    <div class="line_style">
                      <div class="td1">
                        <div class="tcenter">企业名称</div>
                      </div>
                      <div class="td2">
                        <div class="tcenter">数量</div>
                      </div>
                    </div>
                    <div
                      class="line_style hoverBtn"
                      v-for="(item, index) in dataRzRank"
                      :key="index"
                      @click="
                        onEnterpriseSoft(item.companyName, item.companyId)
                      "
                    >
                      <div class="td1">
                        <div class="num">{{ index + 1 }}</div>
                        <div class="text tit_overflow">
                          {{ item.companyName }}
                        </div>
                      </div>
                      <div class="td2">
                        <div class="num1">{{ item.num }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item key="3">
          <div class="category_main">
            <v-row class="category_top">
              <v-col sm="12" md="12">
                <div class="item_shangbiao">
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num">
                          <p
                            v-if="dataAmount[0] && dataAmount[0].num"
                            class="text"
                          >
                            电路设计申请：{{ dataAmount[0].num }}
                          </p>
                          <p class="test" v-else>0</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">集成电路申请趋势</div>
                  <div class="chartBox" ref="chartDom8"></div>
                </div>
              </v-col>
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">集成电路授权增长趋势</div>
                  <div class="chartBoxTwo" ref="chartDom8Two"></div>
                </div>
              </v-col>
              <v-col sm="12" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">集成电路拥有量排行</div>
                  <div class="chartBox list_box" ref="chartDom5">
                    <div class="line_style">
                      <div class="td1">
                        <div class="tcenter">企业名称</div>
                      </div>
                      <div class="td2">
                        <div class="tcenter">数量</div>
                      </div>
                    </div>

                    <div
                      class="line_style"
                      v-for="(item, index) in dataRank"
                      :key="index"
                    >
                      <div class="td1">
                        <div class="num">{{ index + 1 }}</div>
                        <div class="text tit_overflow">
                          {{ item.companyName }}
                        </div>
                      </div>
                      <div class="td2">
                        <div class="num1">{{ item.num }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item key="4">
          <div class="category_main">
            <v-row class="category_top">
              <v-col sm="12" md="=12">
                <div class="item_shangbiao">
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num">
                          <p class="text">
                            软件产品数：{{ productsNum[0].num }}
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num_blue">
                          <p class="text">
                            软件企业总数：{{ productsNum[1].num }}
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num_green">
                          <p class="text">
                            双软企业总数：{{ productsNum[2].num }}
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">软件企业年度累计</div>
                  <div class="chartBox" ref="chartDom9"></div>
                </div>
              </v-col>
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">软件企业年度新增</div>
                  <div class="chartBoxTwo" ref="chartDom9One"></div>
                </div>
              </v-col>
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">软件产品年度累计</div>
                  <div class="chartBox" ref="chartDom9Two"></div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="6" md="4" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">软件产品年度新增</div>
                  <div class="chartBoxTwo" ref="chartDom9Three"></div>
                </div>
              </v-col>
              <v-col sm="6" md="8" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">园区双软企业列表</div>
                  <div class="chartBox list_box" ref="chartDom5">
                    <div class="line_style">
                      <div class="td_shuangR01">
                        <div class="tcenter">序号</div>
                      </div>
                      <div class="td_shuangR02">
                        <div class="tcenter">证书编号</div>
                      </div>
                      <div class="td_shuangR03">
                        <div class="tcenter">企业名称</div>
                      </div>
                      <div class="td_shuangR04">
                        <div class="tcenter">备注</div>
                      </div>
                    </div>
                    <div
                      class="line_style"
                      v-for="(item, index) in dataSuangRuan"
                      :key="index"
                    >
                      <div class="td_shuangR01">
                        <div class="text tit_overflow">
                          {{ item.rank }}
                        </div>
                      </div>
                      <div class="td_shuangR02">
                        <div class="num1">{{ item.asset_id }}</div>
                      </div>
                      <div class="td_shuangR03">
                        <div class="num1">{{ item.company_name }}</div>
                      </div>
                      <div class="td_shuangR04">
                        <div class="num1">{{ item.remark }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item key="5">
          <div class="category_main">
            <v-row class="category_top">
              <v-col sm="12" md="12">
                <div class="item_shangbiao">
                  <div class="lefts_shangbiao">
                    <div>
                      <div class="num_wrapper">
                        <span class="num">
                          <p v-if="pctNum[0] && pctNum[0].num" class="text">
                            PCT总数：{{ pctNum[0].num }}
                          </p>
                          <p v-else class="test">0</p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="6" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">PCT年度累计统计</div>
                  <div class="chartBox" ref="chartDom9Pct"></div>
                </div>
              </v-col>
              <v-col sm="6" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">PCT年度新增统计</div>
                  <div class="chartBoxTwo" ref="chartDom9AddPct"></div>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom_pct">
              <v-col sm="6" md="12" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">企业PCT排有量排名</div>
                  <v-row>
                    <v-col sm="12" md="4">
                      <div class="chartBox list_box" ref="chartDom5">
                        <div class="line_style">
                          <div class="td1">
                            <div class="tcenter">企业名称</div>
                          </div>
                          <div class="td2">
                            <div class="tcenter">数量</div>
                          </div>
                        </div>
                        <div
                          class="line_style @green"
                          v-for="(item, index) in dataPctRank"
                          :key="index"
                        >
                          <div class="td1">
                            <div class="num">{{ item.rank }}</div>
                            <div class="text tit_overflow">
                              {{ item.company_name }}
                            </div>
                          </div>
                          <div class="td2">
                            <div class="num1">{{ item.num }}</div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col sm="12" md="4">
                      <div class="chartBox list_box" ref="chartDom5">
                        <div class="line_style">
                          <div class="td1">
                            <div class="tcenter">企业名称</div>
                          </div>
                          <div class="td2">
                            <div class="tcenter">数量</div>
                          </div>
                        </div>
                        <div
                          class="line_style"
                          v-for="(item, index) in dataPctRankTwo"
                          :key="index"
                        >
                          <div class="td1">
                            <div class="num">{{ item.rank }}</div>
                            <div class="text tit_overflow">
                              {{ item.company_name }}
                            </div>
                          </div>
                          <div class="td2">
                            <div class="num1">{{ item.num }}</div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col sm="12" md="4">
                      <div class="chartBox list_box" ref="chartDom5">
                        <div class="line_style">
                          <div class="td1">
                            <div class="tcenter">企业名称</div>
                          </div>
                          <div class="td2">
                            <div class="tcenter">数量</div>
                          </div>
                        </div>
                        <div
                          class="line_style"
                          v-for="(item, index) in dataPctRankThree"
                          :key="index"
                        >
                          <div class="td1">
                            <div class="num">{{ item.rank }}</div>
                            <div class="text tit_overflow">
                              {{ item.company_name }}
                            </div>
                          </div>
                          <div class="td2">
                            <div class="num1">{{ item.num }}</div>
                          </div>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
        <v-tab-item key="6">
          <div class="category_main">
            <div class="firm_list_wrapper_biao">
              <div class="bartaber">
                <span class="title01">
                  <span
                    class="text"
                    v-if="dataStandard[0] && dataStandard[0].num"
                    >国家标准：{{ dataStandard[0].num }}</span
                  >
                  <span class="text" v-else>0</span>
                </span>

                <span class="title02">
                  <span
                    class="text"
                    v-if="dataStandard[1] && dataStandard[1].num"
                    >国体标准：{{ dataStandard[1].num }}</span
                  >
                  <span class="text" v-else>0</span>
                </span>
                <span class="title03"
                  ><span
                    class="text"
                    v-if="dataStandard[2] && dataStandard[2].num"
                    >行业标准：{{ dataStandard[2].num }}</span
                  >
                  <span class="text" v-else>0</span>
                </span>
              </div>
              <v-card-text>
                <table>
                  <thead>
                    <tr>
                      <th class="compName">公司名称</th>
                      <th>
                        <span class="stdType"> 标准类型 </span>
                        <span class="stdNo"> 标准号 </span>
                        <span class="stdName">标准名称</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in dataStandardTable" :key="index">
                      <td data-label="公司名称" style="width: 20%">
                        {{ item.companyName }}
                      </td>
                      <td>
                        <div
                          class="bor_b"
                          v-for="(val, i) in item.std"
                          :key="i"
                        >
                          <div class="tabletype">
                            {{ val.type }}
                          </div>
                          <div class="borderleft">
                            <div
                              class="tableitems"
                              v-for="(item, j) in val.items"
                              :key="j"
                            >
                              <div class="stdNumber">
                                {{ item.number }}
                              </div>
                              <div class="tableName">
                                {{ item.name }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-----table---->
              </v-card-text>
            </div>
          </div>
        </v-tab-item>

        <v-tab-item key="7">
          <div class="category_main">
            <v-row class="category_bottom">
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">工业互联网产业专利总数</div>
                  <!---添加图表切换的自适应---->
                  <!-- <div class="chartBox"  ref="chartDom1"></div> -->
                  <IndustryChart class="chartBox"></IndustryChart>
                </div>
              </v-col>
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">工业互联网专利拥有量排名</div>
                  <ParkRrmark></ParkRrmark>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">3D打印产业专利总量</div>
                  <IndustryChart3d class="chartBox"></IndustryChart3d>
                </div>
              </v-col>
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">3D打印专利拥有量排名</div>
                  <ParkRrmark3d></ParkRrmark3d>
                </div>
              </v-col>
            </v-row>
            <v-row class="category_bottom">
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">生命健康医疗产业专利总量</div>
                  <IndustryCharthealth class="chartBox"></IndustryCharthealth>
                </div>
              </v-col>
              <v-col sm="12" md="6" style="margin-top: -10px">
                <div class="item">
                  <div class="tit">生命健康医疗专利拥有量排名</div>
                  <ParkRrmarkhealth></ParkRrmarkhealth>
                </div>
              </v-col>
            </v-row>
            <!-- 图标07 -->
          </div>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>
<script>
import topNav from "@/components/widgets/topNav.vue";
import BarCharts from "@/components/Echarts/BarCharts.vue";
import LineChart from "@/components/category/LineChart";
import BarChart from "@/components/category/BarChart";
import PatentCharts from "@/components/category/PatentCharts";
import BarChart1 from "@/components/category/BarChart1";
import BarChart2 from "@/components/category/BarChart2";
import technChart from "@/components/category/technChart";
import IndustryChart from "@/components/category/IndustryChart";
import IndustryChart3d from "@/components/category/IndustryChart3d";
import IndustryCharthealth from "@/components/category/IndustryCharthealth";
import ParkRrmarkYuanqu from "@/components/category/ParkRrmarkYuanqu";
import ParkRrmark from "@/components/category/ParkRrmark";
import ParkRrmark3d from "@/components/category/ParkRrmark3d";
import ParkRrmarkhealth from "@/components/category/ParkRrmarkhealth";
// import  {EleResize} from "../assets/js/esresize.js";
import echarts from "echarts";
import { mapActions, mapGetters } from "vuex";
import { setTimeout } from "timers";
import { Item } from "muuri";
import { Console } from "console";
export default {
  data() {
    return {
      activeKey: "1",
      myChart1: "",
      myChart2: "",
      myChart3: "",
      myChartsType: "",
      myCHartsEffect: "",
      myChart4: "",
      myChart5: "",
      myChart6: "",
      myChart6Two: "",
      myChart7: "",
      myChart7Two: "",
      myChart8: "",
      myChart8Two: "",
      myChart9: "",
      myChart9One: "",
      myChart9Two: "",
      myChart9Three: "",
      myChart9Pct: "",
      myChart9AddPct: "",
      dataSixTwo: [],
      headers6: [
        { text: "排名", value: "rank", sortable: false },
        { text: "企业名称", value: "company_name", sortable: false },
        { text: "PCT数量", value: "num", sortable: false },
      ],

      chartsdatafour: [
        {
          value: "",
          name: "",
        },
      ],
      categorySum: [],
      categorySumTwo: [],
      dataAxis: [],
      dataAxis8: [],
      data6Sum: "",
      dataAxis9: [],
      data9: {
        data9AxisY: [],
      },
      dataAxis6: [],
      dataAxisY6: [],
      dataAxis7: [],
      dataAxisY7: [],
      ldata: [],
      sdata: [],
      data3: [],
      dataY: [],
      rectangular: [
        {
          value: "",
          name: "",
        },
      ],
      pataType: [
        {
          value: this.news,
          name: this.namepa,
        },
      ],
      news: [],
      data1: [],
      data2: {
        apply: [],
        total: [],
        invent: [],
        ultiy: [],
        design: [],
      },

      data8: {
        data8Num: [],
      },
      dataRank: [],
      dataSuangRuan: [],
      datafiveMark: [],
      dataAcc: {
        apply: [],
        registered: [],
        effective: [],
      },
      data6Two: {
        apply6two: [],
        total6two: [],
        design6two: [],
      },
      dataAxisTwoyear: [],
      trademarNum: "",
      registeredNum: "",
      effectiveNum: "",
      effectMonth: [
        {
          month: "",
          num: "",
        },
      ],
      effectLastYear: [
        {
          month: "",
          num: "",
        },
      ],
      dataAxisOne: [],
      AxisYnine: [],
      dataAxis9Two: [],
      AxisYnineTwo: [],
      dataAxisDatapl: [],
      dataplAccNum: [],
      productsNum: [],
      companiesNum: "",
      companiesSum: "",
      RzMonth: [
        {
          month: "",
          num: "",
        },
      ],
      RzLastYear: [
        {
          month: "",
          num: "",
        },
      ],
      dataAmountYear: [],
      dataAmountMonth: [],
      dataAmount: "",
      pctNum: "",
      AxisTread: [],
      dataAxisTread: [],
      dataAxisSeven: [],
      dataSeven: [],
      dataAxisXSeven: [],
      dataAxisYSeven: [],
      dataRzRank: [],
      rzDataNumrising: "",
      rzDataNum: [],
      dataPctAccNum: [],
      dataPctAccYear: [],
      dataPctLineNum: [],
      PctLineNumber: [],
      PctLineYear: [],
      dataPctRank: [],
      dataPctRankTwo: [],
      dataPctRankThree: [],
      dataStandard: [],
      effPatent: [],
      lister: [],
      dataStandardTable: [],
      pctNumNum: "",
      resultList: [
        {
          value: "",
          name: "",
        },
      ],
      paValidout: [
        {
          value: "",
          name: "",
        }, //专利有效状态
      ],
      paTypeValid: [
        {
          value: "",
          name: "",
        }, //专利类型
      ],
      stdter: [],
      pkiliter: [
        {
          name: "",
          number: "",
        },
      ],
    };
  },
  components: {
    topNav,
    BarCharts,
    LineChart,
    BarChart,
    PatentCharts,
    BarChart1,
    BarChart2,
    technChart,
    IndustryChart,
    IndustryChart3d,
    IndustryCharthealth,
    ParkRrmarkYuanqu,
    ParkRrmark,
    ParkRrmark3d,
    ParkRrmarkhealth,
  },
  created() {
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     this.handleChange();
    //   }, 1000);
    // });
  },
  //监听路由的页面跳转
  computed: {
    ...mapGetters("category", ["getChartDataByCode", "chartDict"]),
    menuList() {
      return this.$store.state.menuList;
    },
    //专利导航栏数据
    pa_all_amount_comp() {
      return this.getChartDataByCode("pa_all_amount_comp");
    },
    //园区01
    pa_application_grant_trend() {
      return this.getChartDataByCode("pa_application_grant_trend");
    },
    //园区02
    pa_type_grant_trend() {
      return this.getChartDataByCode("pa_type_grant_trend");
    },
    //03专利类型分布
    pa_type_detail() {
      return this.getChartDataByCode("pa_type_detail");
    },
    //04专利法律状态分布
    pa_legaltag_outline() {
      return this.getChartDataByCode("pa_legaltag_outline");
    },
    //05有效分布
    pa_valid_outline() {
      return this.getChartDataByCode("pa_valid_outline");
    },
    //06园区专利技术分布
    pa_ipc_outline() {
      return this.getChartDataByCode("pa_ipc_outline");
    },
    //商标导航数据
    tm_amount_comp() {
      return this.getChartDataByCode("tm_amount_comp");
    },
    // //07年度商标累计总数
    // tm_application_trend() {
    //   return this.getChartDataByCode("tm_application_trend");
    // },
    //软著导航数据
    rz_amount_comp() {
      return this.getChartDataByCode("rz_amount_comp");
    },
    //软著的排行榜
    rz_company_rank() {
      return this.getChartDataByCode("rz_company_rank");
    },
    //集成电路的排行量
    ic_company_rank() {
      return this.getChartDataByCode("ic_company_rank");
    },
    //商标排行榜
    tm_company_rank() {
      return this.getChartDataByCode("tm_company_rank");
    },
    //集成电路的导航栏数据
    ic_amount_comp() {
      return this.getChartDataByCode("ic_amount_comp");
    },
    //pct导航数据
    pa_pct_amount_comp() {
      return this.getChartDataByCode("pa_pct_amount_comp");
    },
    //双软导航栏的数据
    sr_prod_company_comp() {
      return this.getChartDataByCode("sr_prod_company_comp");
    },
    //双软排行量
    sr_prod_company_list() {
      return this.getChartDataByCode("sr_prod_company_list");
    },
    //pct排行量
    pa_pct_company_rank() {
      return this.getChartDataByCode("pa_pct_company_rank");
    },
    //标准制定的标签数据
    std_all_amount_outline() {
      return this.getChartDataByCode("std_all_amount_outline");
    },
  },
  watch: {
    $route: function (to, from) {
      this.activeKey = to.path;
    },
    //专利导航栏数据
    pa_all_amount_comp(newValue) {
      this.categorySum = newValue;
      let effPatent = [];
      this.categorySum.forEach((item) => {
        let item1 = item["有效发明专利"];
        let item2 = item["有效外观设计"];
        let item3 = item["有效实用新型"];
        effPatent = effPatent.concat(item1 + item2 + item3);
      });
      this.effPatent = effPatent.toString();
    },
    //园区01
    pa_application_grant_trend(newValue) {
      let val = newValue.reduce(
        function (initVal, it) {
          initVal.years.add(it.year);
          if (!initVal.grant[it.year]) {
            initVal.grant[it.year] = 0;
          }
          if (!initVal.application[it.year]) {
            initVal.application[it.year] = 0;
          }
          initVal.grant[it.year] += it.num_grant;
          initVal.application[it.year] += it.num_application;
          return initVal;
        },
        { years: new Set(), grant: {}, application: {} }
      );

      this.dataAxis = Array.from(val.years);
      this.data2.apply = Object.values(val.application);
      this.data2.total = Object.values(val.grant);
    },
    //园区02
    pa_type_grant_trend(newValue) {
      let echararr = [];
      for (var i = 0; i < newValue.length; i++) {
        var arrindex = echararr.findIndex((item, index, arr) => {
          return item.year === newValue[i].year;
        });
        if (arrindex == -1) {
          echararr.push({
            year: newValue[i].year,
            data: [newValue[i].data],
          });
        } else {
          echararr[arrindex].data.push(newValue[i].data);
        }
        let datatwo = [];
        let yearChartstwo = [];
        let numarr01 = [];
        let numarr02 = [];
        let numarr03 = [];
        echararr.forEach((item) => {
          let year = item.year;
          let data = item.data;
          let sum001 = 0;
          let sum002 = 0;
          let sum003 = 0;
          data.forEach((item) => {
            sum001 += item["发明专利"];
            sum002 += item["外观设计"];
            sum003 += item["实用新型"];
          });
          numarr01 = numarr01.concat(sum001);
          numarr02 = numarr02.concat(sum002);
          numarr03 = numarr03.concat(sum003);
          yearChartstwo = yearChartstwo.concat(year);
        });
        this.dataAxis1 = yearChartstwo;
        this.data2.invent = numarr01;
        this.data2.design = numarr02;
        this.data2.ultiy = numarr03;
      }
    },
    //03专利类型分布
    pa_type_detail(newValue) {
      let result = newValue.reduce((cur, next) => {
        if (Object.keys(cur).length > 0) {
          Object.keys(cur).map((item, index) => {
            cur[item] += next.data[item];
          });
        } else {
          cur = next.data;
        }
        return cur;
      }, {});
      this.resultList = Object.entries(result).map(([key, value]) => ({
        name: key,
        value: value,
      }));
    },

    //04专利法律状态分布
    pa_legaltag_outline(newValue) {
      let chartsdatafour = newValue.reduce((cur, next) => {
        return cur;
      }, {});
      this.chartsdatafour = newValue.map((item) => ({
        value: item.num,
        name: item.legalTag,
      }));
    },
    //05专利分布
    pa_valid_outline(newValue) {
      let paValidout = newValue.reduce((cur, next) => {
        return cur;
      }, {});
      this.paValidout = newValue.map((item) => ({
        value: item.num,
        name: item.legalStatus,
      }));
    },
    //06园区专利技术分布
    pa_ipc_outline(newValue) {
      this.chartsdatapicthree = newValue.slice(0, 10);
      this.rectangular = this.chartsdatapicthree.map((item) => {
        return {
          value: item.num,
          name: item.ipcName.slice(0, 10),
        };
      });
    },
    //商标导航栏数据
    tm_amount_comp(newValue) {
      this.trademarNum = newValue;
    },
    //软著的导航数据
    rz_amount_comp(newValue) {
      this.rzDataNum = newValue;
    },
    // //07年度商标累计总数
    // tm_application_trend(newValue) {
    //    console.log(newValue,'---newValue-----')
    // },
    //软著的排行榜
    rz_company_rank(newValue) {
      this.dataRzRank = newValue.slice(0, 20);
    },
    //集成电路的排行量
    ic_company_rank(newValue) {
      this.dataRank = newValue.slice(0, 20);
    },
    //商标的排行榜
    tm_company_rank(newValue) {
      this.datafiveMark = newValue.slice(0, 20);
    },
    //集成电路的导航栏数据
    ic_amount_comp(newValue) {
      this.dataAmount = newValue;
    },
    //PCT数量
    pa_pct_amount_comp(newValue) {
      this.pctNum = newValue;
    },
    //双软导航数据
    sr_prod_company_comp(newValue) {
      this.productsNum = newValue;
    },
    //双软排行量
    sr_prod_company_list(newValue) {
      this.dataSuangRuan = newValue;
    },
    //pct排行量
    pa_pct_company_rank(newValue) {
      this.dataPctRank = newValue.slice(0, 10);
      this.dataPctRankTwo = newValue.slice(10, 20);
      this.dataPctRankThree = newValue.slice(20, 29);
    },
    //标准制定导航数据
    std_all_amount_outline(newValue) {
      this.dataStandard = newValue;
    },
    //集成电路的授权增长趋势
    ic_grant_trend(newValue) {
      console.log(newValue, "===newValue==");
    },
  },
  mounted() {
    var codes = [
      "pa_all_amount_comp",
      "pa_application_grant_trend",
      "pa_type_grant_trend",
      "pa_type_detail",
      "pa_legaltag_outline",
      "pa_valid_outline",
      "pa_ipc_outline",
      // "tm_application_trend",
      "tm_amount_comp",
      "rz_amount_comp",
      "rz_company_rank",
      "ic_company_rank",
      "tm_company_rank",
      "pa_pct_amount_comp",
      "sr_prod_company_comp",
      "sr_prod_company_list",
      "pa_pct_company_rank",
      "std_all_amount_outline",
      "ic_grant_trend",
    ];
    for (let code of codes) {
      this.queryChartData({ code: code });
    }
  },

  destroyed() {
    window.removeEventListener("resize", this.initChart, 20);
    window.removeEventListener("resize", this.initChart1, 20);
  },
  methods: {
    //添加的自适应的js
    genRandomIndex(length) {
      return Math.ceil(Math.random() * (length - 1));
    }, //滚动条的样式
    ...mapActions("category", [
      "getChartGroup",
      "queryChartData",
      "getChartData",
      "getReportData",
    ]),

    //集团的基本信息
    initChartGroup() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
        },
      };
      //集团的基本信息
      this.getChartGroup({
        data: data,
        handle(res) {},
      });
    },
    //切换到商标的图表的数据
    handleChange(val) {
      if (val == "0") {
        this.initChartGroup();
        this.initChartsChart();
        setTimeout(() => {
          // this.myChart1 = echarts.init(this.$refs.chartDom1);
          this.myChart1 = echarts.init(document.getElementById("chartOne"));
          this.myChart2 = echarts.init(this.$refs.chartDom2);
          this.myChart3 = echarts.init(this.$refs.chartDom3);
          this.myChartsType = echarts.init(this.$refs.chartDom3Type);
          this.myCHartsEffect = echarts.init(this.$refs.chartDom4Effect);
          this.myChart4 = echarts.init(this.$refs.chartDom4);
          this.setChart1();
          this.setChart2();
          this.setChart3();
          this.setChart3Type();
          this.setChart4Effect();
          this.setChart4();
        }, 1500);
        window.addEventListener("resize", () => {
          this.myChart1.resize();
          this.myChart2.resize();
          this.myChart3.resize();
          this.myChartsType.resize();
          this.myCHartsEffect.resize();
          this.myChart4.resize();
        });
        //  this.val="1"="display:none;"
      }
      if (val == "1") {
        this.initChartsCharSix();
        setTimeout(() => {
          this.myChart6 = echarts.init(this.$refs.chartDom6);
          this.myChart6Two = echarts.init(this.$refs.chartDom6Two);
          this.setChart6();
          this.setChart6Two();
        }, 1500);
        // window.addEventListener("click", function () {
        //     this.myChart6.resize();
        //     this.myChart6Two.resize();
        // });
        window.addEventListener("resize", () => {
          this.myChart6.resize();
          this.myChart6Two.resize();
        });
      }

      if (val == "2") {
        this.initChartSeven();
        window.addEventListener("resize", () => {
          this.myChart7.resize();
          this.myChart7Two.resize();
        });
        setTimeout(() => {
          this.myChart7 = echarts.init(this.$refs.chartDom7);
          this.myChart7Two = echarts.init(this.$refs.chartDom7Two);
          this.setChart7();
          this.setChart7Two();
        }, 1500);
      }
      if (val == "3") {
        this.grantTread();
        this.initChartEight();
        setTimeout(() => {
          this.myChart8 = echarts.init(this.$refs.chartDom8);
          this.myChart8Two = echarts.init(this.$refs.chartDom8Two);
          this.setChart8();
          this.setChart8Two();
        }, 1500);
        window.addEventListener("resize", () => {
          this.myChart8.resize();
          this.myChart8Two.resize();
        });
      }
      if (val == "4") {
        this.initChartProd();
        this.initChartNine();
        setTimeout(() => {
          this.myChart9 = echarts.init(this.$refs.chartDom9);
          this.myChart9One = echarts.init(this.$refs.chartDom9One);
          this.myChart9Two = echarts.init(this.$refs.chartDom9Two);
          this.myChart9Three = echarts.init(this.$refs.chartDom9Three);
          this.setChart9();
          this.setChart9One();
          this.setChart9Two();
          this.setChart9Three();
        }, 1500);
        window.addEventListener("resize", () => {
          this.myChart9.resize();
          this.myChart9One.resize();
          this.myChart9Two.resize();
          this.myChart9Three.resize();
        });
      }
      if (val == "5") {
        this.initChartPct();
        // this.initChartPctRank();
        // this.initPctNum();
        this.timer = setTimeout(() => {
          this.myChart9Pct = echarts.init(this.$refs.chartDom9Pct);
          this.myChart9AddPct = echarts.init(this.$refs.chartDom9AddPct);
          this.setChart9Pct();
          this.setChart9AddPct();
        }, 1500);
        window.addEventListener("resize", () => {
          this.myChart9Pct.resize();
          this.myChart9AddPct.resize();
        });
      }
      if (val == "6") {
        setTimeout(() => {
          this.myStandardsTable();
        }, 1500);
      }
      if (val == "7") {
        setTimeout(() => {
          // this.myStandards(); //标准制定
          // this.myStandardsTable();
          this.timer = setTimeout(() => {
            this.myChart9Pct = echarts.init(this.$refs.chartDomImport);
            // this.myChart9AddPct = echarts.init(this.$refs.chartDom9AddPct);
            this.setChart9Pct();
            // this.setChart9AddPct();
          }, 1500);
          window.addEventListener("resize", () => {
            this.myChart9Pct.resize();
            // this.myChart9AddPct.resize();
          });
        }, 1500);
      }
    },
    initChartsChart() {
      this.queryChartData({ code: "pa_application_grant_trend" }); //园区的图表01
      this.queryChartData({ code: "pa_type_grant_trend" }); //专利类型授权趋势02
      this.queryChartData({ code: "pa_type_detail" }); //专利类型分布03
      this.queryChartData({ code: "pa_legaltag_outline" }); //专利04
      this.queryChartData({ code: "pa_valid_outline" }); //专利05
      this.queryChartData({ code: "pa_ipc_outline" }); //06园区专利技术分布
      // this.queryChartData({ code: "tm_application_trend" }); //07年度商标累计总数
      this.queryChartData({ code: "rz_amount_comp" }); //软著的导航数据
      this.queryChartData({ code: "rz_company_rank" }); //软著排行量
      this.queryChartData({ code: "ic_company_rank" }); //集成电路的排行量
      this.queryChartData({ code: "tm_company_rank" }); ///商标的排名量
      this.queryChartData({ code: "ic_amount_comp" }); //集成电路的导航栏数据
      this.queryChartData({ code: "pa_pct_amount_comp" }); //PCT数量
      this.queryChartData({ code: "sr_prod_company_comp" }); //双软导航数据
      this.queryChartData({ code: "sr_prod_company_list" }); //双软企业排行量
      this.queryChartData({ code: "pa_pct_company_rank" }); //PCT排行量
      this.queryChartData({ code: "std_all_amount_outline" }); //标准制定标签数据
      this.queryChartData({ code: "ic_grant_trend" }); //集成电路的授权增长趋势
    },

    //年度商标累计总数
    initChartsCharSix() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "tm_application_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.chartsdatatwo = res.message.dataAcc; //累加
          _this.dataSixTwo = res.message.data; //新增总数
          let yearSixdataAcc = [];
          // 年度商标累计新增总数
          let sum6dataAcc = [];
          _this.chartsdatatwo.forEach((item) => {
            let data = item.data;
            let year = item.year;
            yearSixdataAcc = yearSixdataAcc.concat(year).sort();
            sum6dataAcc = sum6dataAcc.concat(data);
          });
          _this.dataAxis6 = yearSixdataAcc;
          _this.sum6dataAcc = sum6dataAcc;
          let registeredAcc = [];
          let effectiveAcc = [];
          let appliedAcc = [];
          _this.sum6dataAcc.forEach((item) => {
            let registered = item["已注册"];
            let effective = item["已注册有效"];
            let applied = item["已申请"];
            registeredAcc = registeredAcc.concat(registered);
            effectiveAcc = effectiveAcc.concat(effective);
            appliedAcc = appliedAcc.concat(applied);
          });
          _this.dataAcc.apply = appliedAcc;
          _this.dataAcc.registered = registeredAcc;
          _this.dataAcc.effective = effectiveAcc;
          let registeredSix = [];
          let effectiveSix = [];
          let appliedSix = [];
          let yearSix = [];
          let yearSixData = [];
          _this.dataSixTwo.forEach((item) => {
            let year = item.year;
            let data = item.data;
            yearSix = yearSix.concat(year);
            yearSixData = yearSixData.concat(data);
          });
          _this.yearSixData = yearSixData;
          _this.yearSixData.forEach((item) => {
            let registered = item["已注册"];
            let effective = item["已注册有效"];
            let applied = item["已申请"];
            registeredSix = registeredSix.concat(registered);
            effectiveSix = effectiveSix.concat(effective);
            appliedSix = appliedSix.concat(applied);
          });
          _this.data6Two.apply6two = appliedSix;
          _this.data6Two.total6two = registeredSix;
          _this.data6Two.design6two = effectiveSix;
          _this.dataAxisTwoyear = yearSix;
        },
      });
    },
    //软著累计总数
    initChartSeven() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "rz_grant_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.chartsSeven = res.message.dataAcc;
          _this.dataChartSeven = res.message.data;
          let sevenYear = [];
          let sevenNum = [];
          let dataSevenYear = [];
          let dataSevenNum = [];
          _this.chartsSeven.forEach((item) => {
            let num = item.num;
            let year = item.year;
            sevenYear = sevenYear.concat(year);
            sevenNum = sevenNum.concat(num);
          });
          _this.dataAxisSeven = sevenYear;
          _this.dataSeven = sevenNum;
          _this.dataChartSeven.forEach((item) => {
            let year = item.year;
            let num = item.num;
            dataSevenYear = dataSevenYear.concat(year);
            dataSevenNum = dataSevenNum.concat(num);
          });
          _this.dataAxisXSeven = dataSevenYear;
          _this.dataAxisYSeven = dataSevenNum;
        },
      });
    },

    //集成电路申请趋势
    initChartEight() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "ic_application_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.chartsEight = res.message.dataAcc;
          let echararrEightNum = [];
          for (var i = 0; i < _this.chartsEight.length; i++) {
            var arrindex = echararrEightNum.findIndex((item, index, arr) => {
              return item.year === _this.chartsEight[i].year;
            }); //获取下标
            if (arrindex == -1) {
              echararrEightNum.push({
                year: _this.chartsEight[i].year,
                month: [_this.chartsEight[i].month],
                num: [_this.chartsEight[i].num],
              });
            } else {
              echararrEightNum[arrindex].month.push(_this.chartsEight[i].month);
              echararrEightNum[arrindex].num.push(_this.chartsEight[i].num);
            }
            let numApplication = [];
            let numGrant = [];
            let yearCharts = [];
            echararrEightNum.forEach((item) => {
              let year = item.year;
              let month = item.month;
              let num = item.num;
              let sumnApplication = 0;
              let sumnGrant = 0;
              for (var i in month) {
                sumnApplication += month[i];
              }
              numApplication = numApplication.concat(sumnApplication);
              for (var K in num) {
                sumnGrant += num[K];
              }
              numGrant = numGrant.concat(sumnGrant);
              yearCharts = yearCharts.concat(year);
            });
            _this.dataAxis8 = yearCharts;
            _this.data8.data8Num = numGrant;
          }
        },
      });
    },
    //集成电路的授权增长趋势
    grantTread() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "ic_grant_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.grantTreaData = res.message.data;
          let grantNum = [];
          let grantYear = [];
          _this.grantTreaData.forEach((item) => {
            let num = item.num;
            let year = item.year;
            grantNum = grantNum.concat(num);
            grantYear = grantYear.concat(year);
          });
          _this.AxisTread = grantNum;
          _this.dataAxisTread = grantYear;
        },
      });
    },

    //导出专利数据
    onExportPa() {
      let _this = this;
      let data = {
        params: {
          type: "pa",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "专利数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },

    //导出商标数据
    onExportTm() {
      let _this = this;
      let data = {
        params: {
          type: "tm",
        },
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      };
      this.getReportData({
        data: data,
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "商标数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },

    //导出软著
    onExportRz() {
      let _this = this;
      let data = {
        params: {
          type: "rz",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "软著数据.xlsx";
          document.body.appendChild(link);
          link.click();
        },
      });
    },

    //导出双软
    onExportSr() {
      let _this = this;
      let data = {
        params: {
          type: "sr",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "双软数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      }).catch((error) => {
        console.log(error);
      });
      // },
    },
    //导出pct
    onExportPct() {
      let _this = this;
      let data = {
        params: {
          type: "pct",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        responseType: "blob",
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "pct数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },
    //导出集成
    onExportIc() {
      let _this = this;
      let data = {
        params: {
          type: "ic",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        responseType: "blob",
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "集成电路数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },
    //导出标准
    onExportStr() {
      let _this = this;
      let data = {
        params: {
          type: "std",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        responseType: "blob",
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "标准制定数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },

    //导出全部数据
    onExportAll() {
      let _this = this;
      let data = {
        params: {
          type: "summary",
        },
        responseType: "blob",
      };
      this.getReportData({
        data: data,
        handle(res) {
          const link = document.createElement("a");
          let blob = new Blob([res], { type: "application/vnd.ms-excel" });
          let objectUrl = URL.createObjectURL(blob);
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "全部数据.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      });
    },

    //双软企业图
    initChartNine() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "sr_company_grant_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.dataNine = res.message.dataAcc;
          _this.dataSrLin = res.message.data;
          let numFive = [];
          let numFiveYear = [];
          let numFiveData = [];
          let numFiveYearData = [];
          _this.dataNine.forEach((item) => {
            let num = item.num;
            let year = item.year;
            numFive = numFive.concat(num);
            numFiveYear = numFiveYear.concat(year);
          });
          _this.dataAxis9 = numFiveYear;
          _this.data9.data9AxisY = numFive;
          _this.dataSrLin.forEach((item) => {
            let num = item.num;
            let year = item.year;
            numFiveData = numFiveData.concat(num);
            numFiveYearData = numFiveYearData.concat(year);
          });
          _this.dataAxisOne = numFiveYearData;
          _this.AxisYnine = numFiveData;
        },
      });
    },
    //双软产品年度累计
    initChartProd() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "sr_prod_grant_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.dataplCode = res.message.dataAcc;
          _this.dataplCodeLin = res.message.data; //折线图
          let dataplCodeAcc = [];
          let dataplCodeAccYear = [];
          let plCodeLinData = [];
          let plCodeLinDataYear = [];
          _this.dataplCode.forEach((item) => {
            let num = item.num;
            let year = item.year;
            dataplCodeAcc = dataplCodeAcc.concat(num);
            dataplCodeAccYear = dataplCodeAccYear.concat(year);
          });
          _this.dataAxisDatapl = dataplCodeAccYear;
          _this.dataplAccNum = dataplCodeAcc;

          _this.dataplCodeLin.forEach((item) => {
            let num = item.num;
            let year = item.year;
            plCodeLinData = plCodeLinData.concat(num);
            plCodeLinDataYear = plCodeLinDataYear.concat(year);
          });
          _this.dataAxis9Two = plCodeLinDataYear;
          _this.AxisYnineTwo = plCodeLinData;
        },
      });
    },
    //PCT年度累计统计
    initChartPct() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "pa_pct_trend",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.dataPctAdd = res.message.dataAcc; //pct累加统计
          _this.dataPctLine = res.message.data; //折线图新增统计
          let dataPctNum = [];
          let dataPctYear = [];
          let dataPctLineNum = [];
          let dataPctLineYear = [];
          _this.dataPctAdd.forEach((item) => {
            let num = item.num;
            let year = item.year;
            dataPctNum = dataPctNum.concat(num);
            dataPctYear = dataPctYear.concat(year);
          });
          _this.dataPctAccNum = dataPctNum;
          _this.dataPctAccYear = dataPctYear;
          _this.dataPctLine.forEach((item) => {
            let num = item.num;
            let year = item.year;
            dataPctLineNum = dataPctLineNum.concat(num);
            dataPctLineYear = dataPctLineYear.concat(year);
          });
          _this.PctLineNumber = dataPctLineNum;
          _this.PctLineYear = dataPctLineYear;
        },
      });
    },
    //标准制定表格
    myStandardsTable() {
      let _this = this;
      let data = {
        params: {
          gid: 1,
          chartTplCode: "std_company_detail",
        },
      };
      this.getChartData({
        data: data,
        handle(res) {
          let list = res.message;
          _this.dataStandardTable = res.message.data;
          // _this.listbian_zun=res.message.data
          let stdArr = [];
          _this.dataStandardTable.forEach((item) => {
            let companyName = item.companyName;
            let std = item.std;
            stdArr = stdArr.concat(std);
          });

          let lister = [];
          _this.stdter = stdArr;
          stdArr.forEach((item) => {
            let items = item.items;
            lister = lister.concat(items);
          });
          _this.listerNumber = lister;
          let letkeyname = [];
          let letkeynumber = [];
          lister.forEach((item) => {
            let name = item.name;
            let number = item.number;
            letkeyname = letkeyname.concat(name);
            letkeynumber = letkeynumber.concat(number);
          });
          _this.letkeyname = letkeyname;
          _this.letkeynumber = letkeynumber;
        },
      });
    },

    initChart() {
      // this.myChart1 = echarts.init();
      // this.myChart1 = echarts.init(this.$refs.chartDom1);
      this.myChart1 = echarts.init(document.getElementById("chartOne"));
      this.myChart2 = echarts.init(document.getElementById("chartDom2"));
      this.myChart3 = echarts.init(document.getElementById("chartDom3"));
      this.myChart2 = echarts.init(document.getElementById("chartDom2"));
      this.myChart3 = echarts.init(document.getElementById("chartDom3"));
      this.myChartsType = echarts.init(this.$refs.chartDom3Type);
      this.myCHartsEffect = echarts.init(this.$refs.chartDom4Effect);
      this.myChart4 = echarts.init(this.$refs.chartDom4);
      window.addEventListener("resize", () => {
        this.myChart1.resize();
        this.myChart2.resize();
        this.myChart3.resize();
        this.myChartsType.resize();
        this.myCHartsEffect.resize();
        this.myChart4.resize();
      });
    },
    initChart1() {
      this.myChart6 = echarts.init(this.$refs.chartDom6);
      this.myChart6Two = echarts.init(this.$refs.chartDom6Two);
      // this.myChart6 = echarts.init(document.getElementById("chartDom6Six"));
      // this.myChart6Two = echarts.init(document.getElementById("chartDomSixTwo"));
      this.myChart7 = echarts.init(this.$refs.chartDom7);
      this.myChart7Two = echarts.init(this.$refs.chartDom7Two);
      this.myChart8 = echarts.init(this.$refs.chartDom8);
      this.myChart8Two = echarts.init(this.$refs.chartDom8Two);
      this.myChart9 = echarts.init(this.$refs.chartDom9);
      this.myChart9One = echarts.init(this.$refs.chartDom9One);
      this.myChart9Two = echarts.init(this.$refs.chartDom9Two);
      this.myChart9Three = echarts.init(this.$refs.chartDom9Three);
      this.myChart9Pct = echarts.init(this.$refs.chartDom9Pct);
      this.myChart9AddPct = echarts.init(this.$refs.chartDom9AddPct);
      window.addEventListener("resize", () => {
        this.myChart6.resize();
        this.myChart6Two.resize();
        this.myChart7.resize();
        this.myChart7Two.resize();
        this.myChart8.resize();
        this.myChart8Two.resize();
        this.myChart9.resize();
        this.myChart9One.resize();
        this.myChart9Two.resize();
        this.myChart9Three.resize();
        this.myChart9Pct.resize();
        this.myChart9AddPct.resize();
      });
    },
    setChart1() {
      let this_ = this;
      let myChart1 = echarts.init(document.getElementById("chartOne"));
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxis,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1,
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            name: "申请趋势",
            data: this.data2.apply,
            type: "line",
            smooth: true,
          },
          {
            name: "授权趋势",
            data: this.data2.total,
            type: "line",
            smooth: true,
          },
        ],
      };
      this.myChart1.setOption(option);
      // window.addEventListener("resize", function () {
      //   this.myChart1.resize();
      // });
      window.addEventListener("resize", function () {
        myChart1.resize();
      });
    },
    setChart2() {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        toolbox: {
          show: false,
        },
        color: [
          "#0095ff",
          // '#3fafff',
          "#33d1b1",
          // '#7fcaff',
          "#5dbcff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        xAxis: [
          {
            // name: '(年)',
            type: "category",
            data: this.dataAxis1,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                // color: '#777C8B'
                color: "#33d1b1",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                // color: '#777C8B'
                color: "#C2C2C2", //深灰
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        series: [
          {
            name: "发明专利",
            type: "bar",
            data: this.data2.invent,
          },
          {
            name: "实用新型",
            type: "bar",
            data: this.data2.ultiy,
          },
          {
            name: "外观专利",
            type: "bar",
            data: this.data2.design,
          },
        ],
      };
      this.myChart2.setOption(option);
      //   window.addEventListener("resize", function () {
      //   this.myChart2.resize();
      // });
    },

    //园区专利技术分布
    setChart3() {
      let option = {
        title: {
          text: "",
          subtext: "",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}",
        },
        calculable: false,
        color: [
          "#48B3FF",
          "#33D1B1",
          "#94D3FF",
          "#6FE9D0",
          "#B3EBE0",
          "#C4E6FF",
          "#FFC143",
          "#FFCF6D",
          "#FFE1A5",
          "#FFECEC",
        ],
        series: [
          {
            breadcrumb: { show: false }, //去掉底部下面黑色
            name: "",
            barWidth: 1000,
            type: "treemap",
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b}",
                  color: "#000",
                },
                borderWidth: 1,
              },
              emphasis: {
                label: {
                  show: true,
                },
              },
            },
            data: this.rectangular,
          },
        ],
      };
      this.myChart3.setOption(option);
      //   window.addEventListener("resize", function () {
      //   this.myChart3.resize();
      // });
    },

    //专利类型分布
    setChart3Type() {
      let option = {
        color: ["#7FCAFF", "#67E0C7", "#FFCF6D", "#33D1B1", "#29A6FF"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        grid: {
          right: "60",
          left: "40",
          top: "20",
          containLabel: true,
        },

        series: [
          {
            name: "",
            type: "pie",
            radius: "70%",
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            //专利类型
            data: this.resultList,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c}",
                  fontSize: 12,
                  borderWidth: 20,
                  borderRadius: 4,
                },
                labelLine: { show: true, length: 10, length2: 20 },
              },
            },
          },
        ],
      };
      this.myChartsType.setOption(option);
      //     window.addEventListener("resize", function () {
      //   this.myChartsType.resize();
      // });
    },
    //专利有效性分布
    setChart4Effect() {
      let option = {
        color: ["#7FCAFF", "#67E0C7", "#FFCF6D", "#33D1B1", "#29A6FF"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        grid: {
          right: "60",
          left: "40",
          top: "20",
          containLabel: true,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: "70%",
            avoidLabelOverlap: true,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            //专利有效性分布
            data: this.paValidout,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c}",
                  fontSize: 12,
                  borderWidth: 20,
                  borderRadius: 4,
                },
                labelLine: { show: true, length: 10, length2: 20 },
              },
            },
          },
        ],
      };
      this.myCHartsEffect.setOption(option);
      //     window.addEventListener("resize", function () {
      //   this.myCHartsEffect.resize();
      // });
    },
    //专利法律状态分布
    setChart4() {
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c}",
        },
        grid: {
          right: "260",
          left: "40",
          top: "40",
          containLabel: true,
        },
        color: [
          "#29A6FF",
          "#7FCAFF",
          "#A6DAFF",
          "#33D1B1",
          "#67E0C7",
          "#B3EBE0",
          "#FFB217",
          "#FFCF6D",
          "#FFE1A5",
        ],

        series: [
          {
            name: "",
            type: "pie",
            radius: ["42%", "76%"],
            // right: "100", //左边图的间距
            avoidLabelOverlap: false,
            minAngle: 15, //最小角度
            startAngle: 136, //起始角度
            label: {
              show: true,
              position: "center",
              textStyle: {
                fontWeight: "normal",
                fontSize: 4,
              },
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "12",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: this.chartsdatafour,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{b} : {c}",
                  fontSize: 12,
                  borderWidth: 20,
                  borderRadius: 4,
                  // padding: [10,20],
                },
                labelLine: { show: true, length: 10, length2: 20 },
              },
            },
          },
        ],
      };

      this.myChart4.setOption(option);
      //   window.addEventListener("resize", function () {
      //   this.myChart4.resize();
      // });
    },
    //年度商标累计总数的
    setChart6() {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        toolbox: {
          show: false,
        },
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        xAxis: [
          {
            type: "category",
            data: this.dataAxis6,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#777C8B",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#C2C2C2",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        series: [
          {
            name: "申请",
            type: "bar",
            data: this.dataAcc.apply,
          },
          {
            name: "注册",
            type: "bar",
            data: this.dataAcc.registered,
          },
          {
            name: "有效",
            type: "bar",
            data: this.dataAcc.effective,
          },
        ],
      };
      this.myChart6.setOption(option);
      //  window.addEventListener("resize", function () {
      //   this.myChart6.resize();
      // });
    },
    //专利排行页面跳转
    oNpart(companyName, companyId) {
      this.$router.push({
        // path: "/knowledge",
        path: "/categoryDetail",
        query: {
          id: companyId,
          name: companyName,
          val: 0,
        },
      });
    },
    //商标table
    onConpanyfiveMark(companyName, companyId) {
      this.$router.push({
        path: "/categoryDetail",
        query: {
          id: companyId,
          name: companyName,
          val: 2,
        },
      });
    },
    //软著table
    onEnterpriseSoft(companyName, companyId) {
      this.$router.push({
        path: "/categoryDetail",
        query: {
          id: companyId,
          name: companyName,
          val: 3,
        },
      });
    },

    //年度商标累计新增总数
    setChart6Two() {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxisTwoyear,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1,
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },

        series: [
          {
            name: "申请",
            data: this.data6Two.apply6two,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AC6A8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
          {
            name: "注册",
            data: this.data6Two.total6two,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0095ff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
          {
            name: "有效",
            data: this.data6Two.design6two,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0095ff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.myChart6Two.setOption(option);
      // window.addEventListener("resize", function () {
      //   this.myChart6Two.resize();
      // });
    },
    //年度软著累计总数(软著)
    setChart7() {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: "0",
          right: "0",
          top: "40",
          bottom: "20",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.dataAxisSeven,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#777C8B",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "C2C2C2",
              },
            },
          },
        ],

        series: [
          {
            type: "bar",
            data: this.dataSeven,
          },
        ],
      };

      this.myChart7.setOption(option);
      //  window.addEventListener("resize", function () {
      //   this.myChart7.resize();
      // });
    },
    setChart7Two() {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "0",
          right: "0",
          top: "20",
          bottom: "20",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxisXSeven,
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#777C8B",
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "C2C2C2",
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            data: this.dataAxisYSeven,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0095ff", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.myChart7Two.setOption(option);
      //   window.addEventListener("resize", function () {
      //   this.myChart7Two.resize();
      // });
    },
    setChart8() {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: "0",
          right: "0",
          top: "40",
          bottom: "20",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.dataAxis8,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#777C8B",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#C2C2C2",
              },
            },
          },
        ],
        series: [
          {
            barWidth: 15, //柱状图的宽度
            type: "bar",
            data: this.data8.data8Num,
          },
        ],
      };
      this.myChart8.setOption(option);
      //     window.addEventListener("resize", function () {
      //   this.myChart8.resize();
      // });
    },
    setChart8Two() {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxisTread,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1, //这里是为了突出显示加上的
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            data: this.AxisTread,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AC6A8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.myChart8Two.setOption(option);
      //   window.addEventListener("resize", function () {
      //   this.myChart8Two.resize();
      // });
    },

    setChart9() {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: "0",
          right: "0",
          top: "40",
          bottom: "20",
          containLabel: true,
        },
        xAxis: [
          {
            // name: '(年)',
            type: "category",
            data: this.dataAxis9,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#777C8B",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "##C2C2C2",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: this.data9.data9AxisY,
            barWidth: 18,
            barMaxWidth: 18,
          },
        ],
      };
      this.myChart9.setOption(option);
      //  window.addEventListener("resize", function () {
      //   this.myChart9.resize();
      // });
    },
    setChart9One() {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxisOne,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1, //这里是为了突出显示加上的
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            data: this.AxisYnine,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AC6A8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.myChart9One.setOption(option);
      //  window.addEventListener("resize", function () {
      //   this.myChart9One.resize();
      // });
    },
    setChart9Two() {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: "0",
          right: "0",
          top: "40",
          bottom: "20",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: this.dataAxisDatapl,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#C2C2C2",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#C2C2C2",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: this.dataplAccNum,
            barWidth: 18,
            barMaxWidth: 18,
          },
        ],
      };
      this.myChart9Two.setOption(option);
    },
    setChart9Three() {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.dataAxis9Two,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "##C2C2C2",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2",
              width: 1,
            },
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        series: [
          {
            data: this.AxisYnineTwo,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AC6A8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.myChart9Three.setOption(option);
    },
    //pct年度累计统计
    setChart9Pct() {
      let option = {
        color: [
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          show: true,
        },
        toolbox: {
          show: false,
        },
        grid: {
          left: "0",
          right: "0",
          top: "40",
          bottom: "20",
          containLabel: true,
        },
        xAxis: [
          {
            // name: '(年)',
            type: "category",
            data: this.dataPctAccYear,
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#777C8B",
              },
            },
            axisTick: {
              lineStyle: {
                color: "#777C8B",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              color: "#777C8B",
            },
            axisLine: {
              lineStyle: {
                color: "#C2C2C2",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: this.dataPctAccNum,
            barWidth: 18,
            barMaxWidth: 18,
            itemstyle: {
              normal: {
                color: "#FF0095FF",
              },
            },
          },
        ],
      };
      this.myChart9Pct.setOption(option);
      //  window.addEventListener("resize", function () {
      //   this.myChart9Pct.resize();
      // });
    },
    //pct的增长
    setChart9AddPct() {
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: true,
        },
        grid: {
          left: "0",
          right: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: this.PctLineYear,
          axisLabel: {
            color: "#777C8B",
          },
          axisTick: {
            lineStyle: {
              color: "#777C8B",
            },
          },
        },
        color: [
          "#5AC6A8",
          "#0095ff",
          "#3fafff",
          "#7fcaff",
          "#ff6836",
          "#ff895d",
          "#ffb217",
          "#ffcf6d",
          "#ffe2a8",
        ],
        yAxis: {
          type: "value",
          axisLabel: {
            color: "#777C8B",
          },
          axisLine: {
            lineStyle: {
              color: "#C2C2C2", //深灰
              width: 1, //这里是为了突出显示加上的
            },
          },
        },
        series: [
          {
            data: this.PctLineNumber,
            type: "line",
            smooth: true,
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#5AC6A8", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#7fcaff", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.myChart9AddPct.setOption(option);
      //    window.addEventListener("resize", function () {
      //   this.myChart9AddPct.resize();
      // });
    },
  },
};
</script>
<style scoped>
.compName {
  line-height: 30px;
  width: 301px;
}
.stdType {
  border-right: 1px solid #ccc;
  line-height: 60px;
  float: left;
  /* width:301px; */
  width: 321px;
}
.stdNo {
  margin-left: 10px;
  line-height: 60px;
  border-right: 1px solid #ccc;
  float: left;
  width: 241px;
}
.stdName {
  margin: 0 auto;
  line-height: 60px;
}
.bor_b {
  border-bottom: 1px solid #e1e5eb;
  display: flex;
  align-items: center;
}
.tabletype {
  margin-right: 20px;
  width: 280px;
  margin-left: 20px !important;
  text-align: center;
}
.tableName {
  width: 590px;
  border-left: 1px solid #e1e5eb;
  text-align: center;
}
.stdNumber {
  width: 220px;
  margin-left: 30px;
}
.tableitems {
  display: flex;
  align-items: center;
}
.borderleft {
  border-left: 1px solid #e1e5eb;
}
table {
  border: 1px solid #ccc;
  width: 100%;
  margin: 0;
  padding: 0;
  border-collapse: collapse;
  border-spacing: 0;
  margin: 0 auto;
  border-bottom: 1px solid #e1e5eb;
}

table tr {
  border: 1px solid #ddd;
  padding: 5px;
  border-bottom: 1px solid #e1e5eb;
}

table th,
table td {
  /* padding: 10px; */
  text-align: center;
  border: 1px solid #ccc;
}

table th {
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
}

@media screen and (max-width: 600px) {
  table {
    border: 0;
  }

  table thead {
    display: none;
  }

  table tr {
    margin-bottom: 10px;
    display: block;
    border-bottom: 2px solid #ddd;
  }

  table td {
    display: block;
    text-align: right;
    font-size: 13px;
    border-bottom: 1px dotted #ccc;
  }

  table td:last-child {
    border-bottom: 0;
  }

  table td:before {
    content: attr(data-label);
    float: left;
    text-transform: uppercase;
    font-weight: bold;
  }
}
.w {
  width: 120px;
}

.note {
  max-width: 100%;
  margin: 0 auto;
}
.chart-show-container {
  height: 285px;
  width: 355px;
}
/* #chartOne{
    width: 100%;
    height: 500px;
    border: 1px solid red;
    margin: 0 auto;
} */
</style>
